import { api } from "../Apis/interceptor";

export const createAddress = function (addrData) {
  return api.post("/api/v1/createAddress/",addrData);
};

export const updateAddress = function (id, addrData) {
  return api.put("/api/v1/updateAddress/" + id, addrData);
};

export const getAddress = function (id, cust_id) {
  return api.get("/api/v1/getAddress/" + id + "/" + cust_id);
};

export const getAllAddress = function (cust_id, associated_id) {
  return api.get("/api/v1/getAllAddress/" + cust_id + "/" + associated_id);
};

export const filter = function (
  skip,
  limit,
  cust_id,
  pattern,
  search,
  sortBy,
  orderBy,
  filterData
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/address_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      pattern: pattern,
      search: search,
      sortBy: sortBy,
      orderBy: orderBy,
      address_name: JSON.stringify(filterData.address_name),
      associated: JSON.stringify(filterData.associated),
      associated_id: JSON.stringify(filterData.associated_id),
    },
  });
};

export const addressMultiDelete = function (ids) {
  return api.delete("/api/v1/addressMultiDelete", {
    params: {
      id: ids,
    },
  });
};

export const createContact = function (contactData) {
  return api.post("/api/v1/createContact/", contactData);
};

export const updateContact = function (id, contactData) {
  return api.put("/api/v1/updateContact/" + id, contactData);
};

export const contactFilter = function (
  skip,
  limit,
  cust_id,
  pattern,
  search,
  sortBy,
  orderBy,
  filterData
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/contact_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      pattern: pattern,
      search: search,
      sortBy: sortBy,
      orderBy: orderBy,
      role: JSON.stringify(filterData.filterRole),
      business_unit: JSON.stringify(filterData.filterBU),
      owner: JSON.stringify(filterData.filterOwner),
      status: JSON.stringify(filterData.filterStatus),
      associated: JSON.stringify(filterData.associated),
      associated_id: JSON.stringify(filterData.associated_id),
      address_name: JSON.stringify(filterData.filterAddr),
    },
  });
};

export const getContact = function (id, cust_id) {
  return api.get("/api/v1/getContact/" + id + "/" + cust_id);
};

export const contactMultiDelete = function (ids) {
  return api.delete("/api/v1/contactMultiDelete", {
    params: {
      id: ids,
    },
  });
};

export const getAddressList = function (
  id,
  cust_id,
  add_skip,
  add_limit,
  searchByAddress
) {
  return api.get("/api/v1/getAddressList", {
    params: {
      id: id,
      cust_id: cust_id,
      skip: add_skip,
      limit: add_limit,
      searchByAddress: searchByAddress,
    },
  });
};

export const addAddressFromPages = function (
  id,
  cust_id,
  name,
  from_page,
  clientAddressForm
) {
  return api.put(
    "/api/v1/addAddressFromPages/" +
      id +
      "/" +
      cust_id +
      "/" +
      name +
      "/" +
      from_page,
    clientAddressForm
  );
};

export const updateAddressFromPages = function (cust_id, editAddressForm) {
  return api.put("/api/v1/updateAddressFromPages/" + cust_id, editAddressForm);
};

export const deleteAddressFromPages = function (address_Id) {
  return api.put("/api/v1/deleteAddressFromPages/" + address_Id);
};

export const getContactList = function (
  id,
  cust_id,
  skip,
  limit,
  searchByContact
) {
  return api.get("/api/v1/getContactList", {
    params: {
      id: id,
      cust_id: cust_id,
      skip: skip,
      limit: limit,
      searchByContact: searchByContact,
    },
  });
};

export const addContactFromPages = function (
  id,
  cust_id,
  name,
  from_page,
  contactForm
) {
  return api.put(
    "/api/v1/addContactFromPages/" +
      id +
      "/" +
      cust_id +
      "/" +
      name +
      "/" +
      from_page,
    contactForm
  );
};

export const updateContactFromPages = function (
  associated_id,
  editContactForm
) {
  return api.put(
    "/api/v1/updateContactFromPages/" + associated_id,
    editContactForm
  );
};

export const deleteContactFromPages = function (contact_id) {
  return api.put("/api/v1/deleteContactFromPages/" + contact_id);
};
